"use client";
import TestimonialsSection from '@/components/sections/TestimonialsSection';
import ContactMapSection from '@/components/sections/quote/ContactMapSection';
import QuoteFormSection from '@/components/sections/quote/QuoteFormSection';
import React from 'react';
import UnifiedCTA from '@/components/sections/UnifiedCTA';
import Breadcrumbs from '@/components/common/Breadcrumbs';

const QuoteContent = () => {
  return (
    <main className="w-full min-h-screen bg-white">
      <Breadcrumbs 
        items={[
          { name: "Request a Quote", url: "/quote" }
        ]} 
      />
      <div className="py-16 px-4 flex flex-col items-center">
      <div className="max-w-[1300px] w-full mx-auto">
        <QuoteFormSection />
        <ContactMapSection />
        <TestimonialsSection />
        {/* <div className="mt-16 mb-28 py-8 border-t border-b border-[#E4E7EC]">
          <div className="max-w-[1216px] mx-auto px-6 md:px-8">
            <div className="flex flex-wrap justify-center md:justify-between items-center gap-8">
              <img src="/images/img_client_logo_blue_a200.svg" alt="Airbnb" className="h-8" />
              <img
                src="/images/img_client_logo_blue_gray_900_01.svg"
                alt="HubSpot"
                className="h-8"
              />
              <img src="/images/img_client_logo.svg" alt="Google" className="h-8" />
              <img src="/images/img_client_logo_gray_600.svg" alt="Microsoft" className="h-8" />
              <img
                src="/images/img_client_logo_deep_orange_300.svg"
                alt="Walmart"
                className="h-8"
              />
              <img src="/images/img_client_logo_purple_800.svg" alt="FedEx" className="h-8" />
            </div>
          </div>
        </div> */}
        <UnifiedCTA
          heading="Know what you are looking for?"
            description="If you already have your label requirements ready. Share your details and our team will send you a tailored estimate in no time."
            primaryLabel="Start a Project"
            primaryHref="/contact"
            variant="dark"
            overlap={false}
            narrow
            cardClassName="max-w-[1200px] mx-auto rounded-[40px] md:rounded-[44px] shadow-[0_32px_64px_-12px_rgba(16,24,40,0.25)] px-[32px] sm:px-[48px] md:px-[72px] py-[72px] sm:py-[88px] md:py-[96px]"
            primaryClassName="min-w-[170px] h-[48px] text-[15px] font-semibold rounded-[8px] px-6 py-3 shadow-none border border-transparent"
        />
      </div>
      </div>
    </main>
  );
};

export default QuoteContent;
